<template>
  <div>
    <div class="top" ref="top" id="top">
      <div class="indexbanner" ref="indexbanner" v-show="isPhone">
        <img :src="getImage(indexbanner)" alt="" ref="imgbanner">
      </div>
      <pctop v-show="!isPhone" ref="pctop" @headtop="headpctop"></pctop>
      <div class="swiper-container" id="nav" ref="nav" v-if="typeflag">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in typeList" :key="index" :class="{on:index == current}" @click="selecttype(item.dictCode, index)"><span>{{item.dictName}}</span></div>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-next" ref="swipernext" v-show="swiperbtn"></div>
        <div class="swiper-button-prev" ref="swiperprev" v-show="swiperbtn"></div>
      </div>
    </div>
    <indexlist :data-type="datatype" :top-height="topheight" :type-data="typeList" :is-pc="!isPhone"></indexlist>
    <menus v-show="isPhone"></menus>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue'
import Swiper from 'swiper'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Menus from '@/views/common/menus'
import Indexlist from '@/views/common/indexlist'
import Pctop from '@/views/common/pctop'
Vue.use(preview)
export default {
  name: 'home',
  components: {
    Menus,
    Indexlist,
    Pctop
  },
  data () {
    return {
      tSpeed: 300,
      fold: true,
      topHeight: '',
      maxLength: 55,
      typeList: [], // tab标签类型
      datatype: '',
      topheight: 0,
      current: 0,
      museumCode: '',
      typeflag: true,
      indexbanner: '',
      isPhone: true,
      screenWidth: '',
      swiperbtn: false,
      defaultbanner: require('../assets/images/defaultbanner.jpg')
    }
  },
  created () {
  },
  watch: {
    // 监听首页banner的高度
    topHeight (val) {
      if (val) {
        if (this.$refs.nav !== undefined) {
          this.topheight = parseInt(this.$refs.nav.clientHeight) + parseInt(val)
        } else {
          this.topheight = parseInt(val)
        }
      }
    }
  },
  mounted () {
    let _this = this
    this.museumCode = this.$route.query.museumCode
    console.log(this.$route.query.theme)
    if (this.$route.query.theme !== undefined && this.$route.query.theme !== '') {
      this.$cookie.set('themeName', this.$route.query.theme)
    } else {
      this.$cookie.set('themeName', '')
    }
    this.$cookie.set('museumCode', this.$route.query.museumCode)
    if (this.$route.query.typeflag !== undefined && parseInt(this.$route.query.typeflag) === 1) {
      this.typeflag = false
      this.$cookie.set('typeflag', false)
    } else {
      this.typeflag = true
      this.$cookie.set('typeflag', true)
    }
    this.settinginfo()
    this.gettypeList(this.$cookie.get('museumCode'))
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth < 768) {
      this.isPhone = true
      this.$refs.imgbanner.onload = function () {
        _this.topHeight = this.height
      }
    } else {
      this.isPhone = false
      this.$nextTick(() => {
        _this.$refs.pctop.headerHeight()
      })
    }
  },
  methods: {
    getImage (val) {
      if (val.indexOf('undefined') === -1 && val !== '') {
        return val
      } else {
        return this.defaultbanner
      }
    },
    headpctop (val) {
      this.topHeight = parseInt(val)
    },
    // 获取留言设置状态
    settinginfo () {
      this.$http({
        // url: this.$http.adornUrl(`/api/leave-message/front/setting/` + this.$cookie.get('museumCode')),
        url: this.$http.adornUrl(`/api/leave-message/front/setting?museumCode=` + this.$cookie.get('museumCode')),
        method: 'get'
      }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data !== undefined) {
            this.indexbanner = res.data.data.banner
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    gettypeList (museumCode) {
      // 获取tab 词典表中的留言类型
      let Url = ''
      if (museumCode !== '') {
        Url = this.$http.adornUrl(`/api/admin/front/dict/parent-museum?parentCode=leaveMessage.type&museumCode=` + museumCode)
      } else {
        Url = this.$http.adornUrl(`/api/admin/front/dict/parent-museum?parentCode=leaveMessage.type`)
      }
      this.$http({
        // url: this.$http.adornUrl(`/api/leave-message/front/dict`),
        url: Url,
        method: 'get'
      }).then((res) => {
        if (res.data.rel === true) {
          let all = {
            'dictCode': 'all',
            'dictName': '全部'
          }
          let data = res.data.data
          this.typeList = data
          this.typeList.splice(0, 0, all)
          if (this.typeList.length === 1 && this.$cookie.get('typeflag')) {
            this.gettypeList('')
          }
          if (this.screenWidth < 768) {
            this.swiperbtn = false
          } else {
            if (this.typeList.length > 12) {
              this.swiperbtn = true
            } else {
              this.swiperbtn = false
            }
          }

          this.$nextTick(() => {
            this.getbanner()
          })
          this.$cookie.set('tabtype', data)
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    // 首页tab滑动及下面的swiper滑动效果
    getbanner () {
      /* eslint-disable no-new */
      if (this.screenWidth < 768) {
        new Swiper(this.$refs.nav, {
          slidesPerView: 6,
          freeMode: true
        })
      } else {
        new Swiper(this.$refs.nav, {
          slidesPerView: 12,
          freeMode: true,
          navigation: {
            nextEl: this.$refs.swipernext,
            prevEl: this.$refs.swiperprev
          }
        })
      }
    },
    selecttype (val, key) {
      this.current = key
      this.datatype = val
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/index';
@import '../../node_modules/swiper/css/swiper.css';
*{touch-action: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);}
.top{
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 88;
}
.indexbanner{
  img{
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
}
#nav{
  background: #fff;
  height: 60px;
  .swiper-slide{
    span{
      display: block;
      line-height: 60px;
      text-align: center;
      font-size: 18px;
      cursor: pointer;
    }
    &.on{
      color: #a11b00;
    }
  }
}
.swiper-wrapper{
  width: 1200px;
}
@media only screen and (max-width: 768px){
  .swiper-wrapper{
    width: 100%;
  }
  #nav{
    height: 46px;
    .swiper-slide{
      span{
        line-height: 46px;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue